import {POST} from "@/services/gateway";
import {trimString} from "@/components/common/utils/trimString";

const listSnapshotDetails = ({sharedDriveIds, folderId, snapshotDateTime, pagination, searchTerm}) => {
  return POST('google/shared-drive-snapshot/search', {sharedDriveIds, folderId, snapshotDateTime, pagination, searchTerm: trimString(searchTerm)})
}

const listBreadcrumps = ({sharedDriveId, folderId, snapshotDate}) => {
  return POST('google/shared-drive-snapshot/breadcrumbs', {sharedDriveId, folderId, snapshotDate})
}


export {
  listSnapshotDetails,
  listBreadcrumps,
}
